import uiBase from "../uiBase";
import css from "./index.scss";
const { h, Component, classNames, render } = omii;

/**
 * items=[{key,nav,pane,__pane}]
 */
export default class extends uiBase {
  static css = css;
  static defaultProps = {
    activeIndex: null, //undefined
    activeKey: null,
    activeEvent: "click", //or hover
  };
  static propTypes = {
    activeIndex: Number,
    activeKey: String,
    activeEvent: String,
  };

  get activeIndex() {
    return this.settings.activeIndex ?? 0;
  }
  get activeKey() {
    return this.settings.activeKey;
  }

  async active({ index, key }, type = null) {
    if (type == null || type == this.settings.activeEvent) {
      if (this.activeKey) {
        this.updateSettings({
          activeKey: key,
        });
      } else {
        this.updateSettings({
          activeIndex: index,
        });
      }
    }
  }

  async render(props) {
    let settings = this.settings;
    let items = props.items ?? settings.items;
    let $navs = [];
    let $panes = [];
    for (let index = 0; index < (items ?? []).length; index++) {
      let item = items[index];
      //lazy load
      //使用activeKey 那就使用activeKey,没有就使用activeIndex

      let isActive = this.activeKey
        ? this.activeKey == item.key
        : index == this.activeIndex;

      let $pane = item.pane;
      if (isActive && typeof $pane == "function") {
        $pane = $pane(item, settings, this);
        // if (result[Symbol.toStringTag] === "Promise") {
        //   this.fire("paneLoading", { index, key: item.key });
        //   result.then((r) => {
        //     item.__pane = r;
        //     this.forceUpdateSelf();
        //     this.fire("paneLoaded", { index, key: item.key });
        //   });
        //   $pane = <oi-loading />;
        // } else {
        //   $pane = item.__pane = result;
        // }
      }
      $panes.push(
        <div
          key={`pane-${item.key ?? index}`}
          className={classNames("pane", {
            active: isActive,
          })}
        >
          {$pane}
        </div>
      );
      $navs.push(
        <div
          key={`nav-${item.key ?? index}`}
          className={classNames("nav", {
            active: isActive,
          })}
          onMouseEnter={() => this.active({ index, key: item.key }, "hover")}
          onclick={() => this.active({ index, key: item.key }, "click")}
        >
          {item.nav}
        </div>
      );
    }
    return (
      <div class="tabs">
        <div class="navs">{$navs}</div>
        <div class="panes">{$panes}</div>
      </div>
    );
  }
}
